import { useSnackbar } from "notistack";
import { Box, Typography, Grid } from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";
import PropTypes from "prop-types";

import { backendPatch } from "@accredo/fe-shared/services/dataService.js";
import Form from "@accredo/fe-shared/components/Form/Form.jsx";
import FormSelect from "../../../components/Form/controls/FormSelect.jsx";
import FormTextField from "../../../components/Form/controls/FormTextField.jsx";
import SubmitButton from "@accredo/fe-shared/components/Form/controls/SubmitButton.jsx";

const anredeOptions = [
  { key: "Herr", label: "Herr" },
  { key: "Frau", label: "Frau" },
];

const PersonalDetailsSection = ({ userData, setUser }) => {
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async (data, formMethods) => {
    let success = false;
    await backendPatch("data/user/account", {
      toSend: data,
      label: "Persönliche Angaben",
      enqueueSnackbar,
      setError: formMethods.setError,
      successMessage: "Daten erfolgreich gespeichert.",
      onSuccess: (response) => {
        if (response.user) {
          setUser(response.user);
          success = true;
        }
      },
    });
    return success;
  };

  return (
    <Box>
      <Typography variant="h2" sx={{ mb: 3 }}>
        Persönliche Angaben
      </Typography>

      <Form
        onSubmit={onSubmit}
        defaultValues={{
          anrede: userData?.anrede || "",
          titel: userData?.titel || "",
          vorname: userData?.vorname || "",
          nachname: userData?.nachname || "",
          email: userData?.email || "",
          telefon: userData?.telefon || "",
          fax: userData?.fax || "",
        }}
      >
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <FormSelect name="anrede" label="Anrede" options={anredeOptions} />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <FormTextField name="titel" label="Titel" fullWidth />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormTextField name="vorname" label="Vorname" fullWidth />
          </Grid>
          <Grid size={{ xs: 12, sm: 64 }}>
            <FormTextField name="nachname" label="Nachname" fullWidth />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormTextField
              name="email"
              label="E-Mail Adresse"
              disabled
              fullWidth
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormTextField name="telefon" label="Telefon" fullWidth />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormTextField name="fax" label="Fax" fullWidth />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <SubmitButton>Speichern</SubmitButton>
          </Grid>
        </Grid>
      </Form>
    </Box>
  );
};

PersonalDetailsSection.propTypes = {
  userData: PropTypes.shape({
    anrede: PropTypes.string,
    titel: PropTypes.string,
    vorname: PropTypes.string,
    nachname: PropTypes.string,
    email: PropTypes.string,
    telefon: PropTypes.string,
    fax: PropTypes.string,
  }).isRequired,
  setUser: PropTypes.func.isRequired,
};

export default PersonalDetailsSection;
